// extracted by mini-css-extract-plugin
export default {"roundedEdgeButton":"RoundedEdgeButton_roundedEdgeButton__SwGfl"};